import { render, staticRenderFns } from "./BaseButtonBorderOrange.vue?vue&type=template&id=aa23c8a4&scoped=true&"
import script from "./BaseButtonBorderOrange.vue?vue&type=script&lang=js&"
export * from "./BaseButtonBorderOrange.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonBorderOrange.vue?vue&type=style&index=0&id=aa23c8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa23c8a4",
  null
  
)

export default component.exports